export default __webpack_public_path__ + "media/images/icon-uncensored-news-black-2f0d8f67f988b549e3cc4e3e12565744.png";